import { render, staticRenderFns } from "./TagSelect.vue?vue&type=template&id=f0773d64&scoped=true"
import script from "./TagSelect.vue?vue&type=script&lang=ts"
export * from "./TagSelect.vue?vue&type=script&lang=ts"
import style0 from "./TagSelect.vue?vue&type=style&index=0&id=f0773d64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0773d64",
  null
  
)

export default component.exports